//frontend/src/dropdownMap/1A5a_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    10: "Approach",
    11: "ConductedBy",
    15: "Gender",
    17: "PovertyLevel",
    18: "PWDStatus",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    Approach: {
        internal: ["_", "__1", "__2"],
        LA: { "_": "ລະຫວ່າງຄົນຕໍ່ຄົນ", "__1": "ຜ່ານສື່ຕ່າງໆ", "__2": "ການລົງຊຸກຍູ້ຊຸມຊົນ" },
        EN: { "_": "Interpersonal", "__1": "Media", "__2": "Community mobilization" }
    },

    ConductedBy: {
        internal: ["dafo", "gst", "lwu", "maf", "npco", "pafo", "wfp"],
        LA: {
            "dafo": "ຫ້ອງການ ກປ  ເມືອງ",
            "gst": "ທີມງານຊ່ວຍເຫຼືອກຸ່ມ",
            "lwu": "ສະຫະພັນແມ່ຍິງ",
            "maf": "ກະຊວງ ກປ",
            "npco": "ຫ້ອງການປະສານງານສູນກາງ",
            "pafo": "ພະແນກ ກປ ແຂວງ",
            "wfp": "ອົງການອາຫານໂລກ"
        },
        EN: { "dafo": "DAFO", "gst": "GST", "lwu": "LWU", "maf": "MAF", "npco": "NPCO", "pafo": "PAFO", "wfp": "WFP" }
    },

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },

    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
